import { css } from 'emotion';
import styled from '@emotion/styled';

const flyoutButtonStyle = css`
  display: block;
  width: 100%;
  padding: 0;
  text-align: left;
`;

export const flyoutLinkStyle = (borderRadius?: number) => css`
  ${flyoutButtonStyle};
  &:focus,
  &:hover {
    border-radius: ${borderRadius || 0}px;
    text-decoration: none;
    background-color: rgba(235, 235, 236, 0.3);
  }
  &:active {
    background-color: rgba(235, 235, 236, 0.5);
  }
`;

export const menuItemsWrapper = (paddingTopBottom?: number) => css`
  padding-top: ${paddingTopBottom || paddingTopBottom === 0 || 14}px;
  padding-bottom: ${paddingTopBottom || paddingTopBottom === 0 || 14}px;
`;

export const flyoutDistributionLinkStyle = css`
  ${flyoutLinkStyle(0)}
  display: flex;
  padding: 8px 0 8px 0;
`;

export const flyoutFooterLinkStyle = css`
  ${flyoutLinkStyle(0)}
  text-align: left;
`;

export const distributionLinkContainerStyle = css`
  display: block;
  width: 100%;
  &:hover {
    text-decoration: none;
  }
`;

export const LinkComponent = styled.div`
  display: block
  &:focus, &:hover {
    text-decoration: none
  }
  &:hover {
    border-radius: 16px;
    background-color: rgba(235, 235, 236, 0.3)
  }
  &:active {
    background-color: rgba(235, 235, 236, 0.5)
  }
`;

export const MenuItemDescriptionContainer = styled.div`
  margin-top: 4px;
`;

export const FlyoutMenuSeparator = styled.div`
  width: 100%;
  height: 2px;
  background: #dfe0e1;
`;
